module.exports = __webpack_public_path__ + "band_9.a4670b5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_9.png
// module id = ZUII
// module chunks = 0